
class PictureWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    that.image = that.querySelector("img");

    if (document.readyState !== "complete") that.classList.add("initial");
    if (that.image) {
      that.image.title = that.image.alt;

      if (that.image.complete) {
        that.classList.add("complete");
      } else {
        that.image.addEventListener("load", () => {
          if (that.image.complete) that.classList.add("complete");
        });
      }
    } else {
      that.classList.add("complete");
    }
  }
}

customElements.define("picture-wrapper", PictureWrapper);
